// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.meicPanel {
  grid-area: meic;
  border-color: rgba(255, 111, 24, 0.35);
  box-shadow: 0 0 26px rgba(255, 111, 24, 0.06);

  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

/* ================= HEADER ================= */

.meicHeader {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 10px;
  flex: 0 0 auto;
}

.meicEyebrow {
  color: #ff8a1f;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  margin-bottom: 5px;
}

.meicHeader h2 {
  margin: 0;
  color: #ff6f18;
  font-size: 20px;
  line-height: 1.05;
}

.meicHeader p {
  margin: 3px 0 0;
  color: #a9b3c4;
  font-size: 12px;
}

.meicBadges {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.meicRegimeBadge {
  color: #f4c542;
  background: rgba(244, 197, 66, 0.08);
  border: 1px solid rgba(244, 197, 66, 0.28);
  padding: 5px 10px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
}

/* ================= SUMMARY ================= */

.meicSummaryRow {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 7px;
  margin-bottom: 8px;
  flex: 0 0 auto;
}

.meicSummaryRow div {
  padding: 7px 9px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.035);
  border: 1px solid rgba(255, 255, 255, 0.065);
  min-width: 0;
}

.meicSummaryRow span {
  display: block;
  color: #8f9bad;
  font-size: 9px;
  margin-bottom: 4px;
  white-space: nowrap;
}

.meicSummaryRow strong {
  display: block;
  color: #f4f7fb;
  font-size: 12px;
  white-space: nowrap;
}

/* ================= ENTRY TIMES ================= */

.meicEntryTimes {
  padding: 7px 10px;
  border-radius: 10px;
  background: rgba(255, 138, 31, 0.055);
  border: 1px solid rgba(255, 138, 31, 0.12);
  margin-bottom: 8px;
  flex: 0 0 auto;
}

.meicEntryTimes span {
  display: block;
  color: #9da8ba;
  font-size: 9px;
  margin-bottom: 4px;
}

.meicEntryTimes strong {
  display: block;
  color: #f4f7fb;
  font-size: 11px;
  line-height: 1.2;
}

/* ================= TABLE ================= */

.meicTableWrap {
  width: 100%;
  flex: 1 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  border-radius: 11px;
  border: 1px solid rgba(255, 255, 255, 0.07);
}

.meicTable {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  font-size: 11px;
}

/* Column sizing: Time | Side | Short | Long | Premium | Mark | PnL | Status | Outcome */

.meicTable th:nth-child(1),
.meicTable td:nth-child(1) {
  width: 10%;
}

.meicTable th:nth-child(2),
.meicTable td:nth-child(2) {
  width: 9%;
}

.meicTable th:nth-child(3),
.meicTable td:nth-child(3),
.meicTable th:nth-child(4),
.meicTable td:nth-child(4) {
  width: 12%;
}

.meicTable th:nth-child(5),
.meicTable td:nth-child(5),
.meicTable th:nth-child(6),
.meicTable td:nth-child(6) {
  width: 9%;
}

.meicTable th:nth-child(7),
.meicTable td:nth-child(7) {
  width: 12%;
}

.meicTable th:nth-child(8),
.meicTable td:nth-child(8) {
  width: 12%;
}

.meicTable th:nth-child(9),
.meicTable td:nth-child(9) {
  width: 10%;
}

.meicTable th,
.meicTable td {
  text-align: left;
  padding: 5px 6px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.055);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-variant-numeric: tabular-nums;
  line-height: 1.15;
}

.meicTable th {
  color: #8f9bad;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  background: #090d15;
  position: sticky;
  top: 0;
  z-index: 2;
}

.meicEntryStart {
  background: rgba(255, 255, 255, 0.022);
}

.meicEntrySecondLeg {
  background: rgba(255, 255, 255, 0.012);
}

.meicEntryStart td {
  border-top: 1px solid rgba(255, 138, 31, 0.12);
}

.meicTimeCell {
  color: #f4f7fb;
  font-weight: 800;
  vertical-align: middle;
  border-right: 1px solid rgba(255, 255, 255, 0.065);
}

/* ================= PILLS ================= */

.meicSidePill {
  display: inline-flex;
  min-width: 38px;
  justify-content: center;
  padding: 2px 5px;
  border-radius: 999px;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.05em;
}

.meicSidePill.call {
  color: #ff9a3d;
  background: rgba(255, 138, 31, 0.12);
  border: 1px solid rgba(255, 138, 31, 0.28);
}

.meicSidePill.put {
  color: #35d9f5;
  background: rgba(53, 217, 245, 0.1);
  border: 1px solid rgba(53, 217, 245, 0.24);
}

.meicStatusPill {
  display: inline-flex;
  min-width: 50px;
  justify-content: center;
  padding: 2px 5px;
  border-radius: 999px;
  font-size: 9px;
  font-weight: 800;
}

.meicStatusPill.open {
  color: #57ff68;
  background: rgba(87, 255, 104, 0.1);
  border: 1px solid rgba(87, 255, 104, 0.24);
}

.meicStatusPill.closed {
  color: #ff604b;
  background: rgba(255, 96, 75, 0.1);
  border: 1px solid rgba(255, 96, 75, 0.24);
}

/* ================= RESPONSIVE ================= */

@media (max-width: 1250px) {
  .meicSummaryRow {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .meicTable {
    font-size: 11px;
  }
}

@media (max-width: 700px) {
  .meicPanel {
    overflow-x: auto;
  }

  .meicHeader {
    flex-direction: column;
  }

  .meicSummaryRow {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .meicEntryTimes strong {
    font-size: 10px;
  }

  .meicTableWrap {
    overflow-x: auto;
  }

  .meicTable {
    min-width: 760px;
    font-size: 10px;
  }

  .meicTable th,
  .meicTable td {
    padding: 5px 4px;
  }

  .meicSidePill,
  .meicStatusPill {
    min-width: auto;
    font-size: 8px;
    padding: 2px 4px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Styles/meicMonitor.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,sCAAsC;EACtC,6CAA6C;;EAE7C,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA,+CAA+C;;AAE/C;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,0CAA0C;EAC1C,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,gDAAgD;;AAEhD;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA,oDAAoD;;AAEpD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,8CAA8C;;AAE9C;EACE,WAAW;EACX,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA,wFAAwF;;AAExF;;EAEE,UAAU;AACZ;;AAEA;;EAEE,SAAS;AACX;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;;;;EAIE,SAAS;AACX;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,mDAAmD;EACnD,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA,8CAA8C;;AAE9C;EACE,oBAAoB;EACpB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA,mDAAmD;;AAEnD;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;AACF","sourcesContent":[".meicPanel {\n  grid-area: meic;\n  border-color: rgba(255, 111, 24, 0.35);\n  box-shadow: 0 0 26px rgba(255, 111, 24, 0.06);\n\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n}\n\n/* ================= HEADER ================= */\n\n.meicHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  margin-bottom: 10px;\n  flex: 0 0 auto;\n}\n\n.meicEyebrow {\n  color: #ff8a1f;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  margin-bottom: 5px;\n}\n\n.meicHeader h2 {\n  margin: 0;\n  color: #ff6f18;\n  font-size: 20px;\n  line-height: 1.05;\n}\n\n.meicHeader p {\n  margin: 3px 0 0;\n  color: #a9b3c4;\n  font-size: 12px;\n}\n\n.meicBadges {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n}\n\n.meicRegimeBadge {\n  color: #f4c542;\n  background: rgba(244, 197, 66, 0.08);\n  border: 1px solid rgba(244, 197, 66, 0.28);\n  padding: 5px 10px;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n/* ================= SUMMARY ================= */\n\n.meicSummaryRow {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 7px;\n  margin-bottom: 8px;\n  flex: 0 0 auto;\n}\n\n.meicSummaryRow div {\n  padding: 7px 9px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.035);\n  border: 1px solid rgba(255, 255, 255, 0.065);\n  min-width: 0;\n}\n\n.meicSummaryRow span {\n  display: block;\n  color: #8f9bad;\n  font-size: 9px;\n  margin-bottom: 4px;\n  white-space: nowrap;\n}\n\n.meicSummaryRow strong {\n  display: block;\n  color: #f4f7fb;\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n/* ================= ENTRY TIMES ================= */\n\n.meicEntryTimes {\n  padding: 7px 10px;\n  border-radius: 10px;\n  background: rgba(255, 138, 31, 0.055);\n  border: 1px solid rgba(255, 138, 31, 0.12);\n  margin-bottom: 8px;\n  flex: 0 0 auto;\n}\n\n.meicEntryTimes span {\n  display: block;\n  color: #9da8ba;\n  font-size: 9px;\n  margin-bottom: 4px;\n}\n\n.meicEntryTimes strong {\n  display: block;\n  color: #f4f7fb;\n  font-size: 11px;\n  line-height: 1.2;\n}\n\n/* ================= TABLE ================= */\n\n.meicTableWrap {\n  width: 100%;\n  flex: 1;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  border-radius: 11px;\n  border: 1px solid rgba(255, 255, 255, 0.07);\n}\n\n.meicTable {\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n  font-size: 11px;\n}\n\n/* Column sizing: Time | Side | Short | Long | Premium | Mark | PnL | Status | Outcome */\n\n.meicTable th:nth-child(1),\n.meicTable td:nth-child(1) {\n  width: 10%;\n}\n\n.meicTable th:nth-child(2),\n.meicTable td:nth-child(2) {\n  width: 9%;\n}\n\n.meicTable th:nth-child(3),\n.meicTable td:nth-child(3),\n.meicTable th:nth-child(4),\n.meicTable td:nth-child(4) {\n  width: 12%;\n}\n\n.meicTable th:nth-child(5),\n.meicTable td:nth-child(5),\n.meicTable th:nth-child(6),\n.meicTable td:nth-child(6) {\n  width: 9%;\n}\n\n.meicTable th:nth-child(7),\n.meicTable td:nth-child(7) {\n  width: 12%;\n}\n\n.meicTable th:nth-child(8),\n.meicTable td:nth-child(8) {\n  width: 12%;\n}\n\n.meicTable th:nth-child(9),\n.meicTable td:nth-child(9) {\n  width: 10%;\n}\n\n.meicTable th,\n.meicTable td {\n  text-align: left;\n  padding: 5px 6px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.055);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-variant-numeric: tabular-nums;\n  line-height: 1.15;\n}\n\n.meicTable th {\n  color: #8f9bad;\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  background: #090d15;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n\n.meicEntryStart {\n  background: rgba(255, 255, 255, 0.022);\n}\n\n.meicEntrySecondLeg {\n  background: rgba(255, 255, 255, 0.012);\n}\n\n.meicEntryStart td {\n  border-top: 1px solid rgba(255, 138, 31, 0.12);\n}\n\n.meicTimeCell {\n  color: #f4f7fb;\n  font-weight: 800;\n  vertical-align: middle;\n  border-right: 1px solid rgba(255, 255, 255, 0.065);\n}\n\n/* ================= PILLS ================= */\n\n.meicSidePill {\n  display: inline-flex;\n  min-width: 38px;\n  justify-content: center;\n  padding: 2px 5px;\n  border-radius: 999px;\n  font-size: 9px;\n  font-weight: 900;\n  letter-spacing: 0.05em;\n}\n\n.meicSidePill.call {\n  color: #ff9a3d;\n  background: rgba(255, 138, 31, 0.12);\n  border: 1px solid rgba(255, 138, 31, 0.28);\n}\n\n.meicSidePill.put {\n  color: #35d9f5;\n  background: rgba(53, 217, 245, 0.1);\n  border: 1px solid rgba(53, 217, 245, 0.24);\n}\n\n.meicStatusPill {\n  display: inline-flex;\n  min-width: 50px;\n  justify-content: center;\n  padding: 2px 5px;\n  border-radius: 999px;\n  font-size: 9px;\n  font-weight: 800;\n}\n\n.meicStatusPill.open {\n  color: #57ff68;\n  background: rgba(87, 255, 104, 0.1);\n  border: 1px solid rgba(87, 255, 104, 0.24);\n}\n\n.meicStatusPill.closed {\n  color: #ff604b;\n  background: rgba(255, 96, 75, 0.1);\n  border: 1px solid rgba(255, 96, 75, 0.24);\n}\n\n/* ================= RESPONSIVE ================= */\n\n@media (max-width: 1250px) {\n  .meicSummaryRow {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .meicTable {\n    font-size: 11px;\n  }\n}\n\n@media (max-width: 700px) {\n  .meicPanel {\n    overflow-x: auto;\n  }\n\n  .meicHeader {\n    flex-direction: column;\n  }\n\n  .meicSummaryRow {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .meicEntryTimes strong {\n    font-size: 10px;\n  }\n\n  .meicTableWrap {\n    overflow-x: auto;\n  }\n\n  .meicTable {\n    min-width: 760px;\n    font-size: 10px;\n  }\n\n  .meicTable th,\n  .meicTable td {\n    padding: 5px 4px;\n  }\n\n  .meicSidePill,\n  .meicStatusPill {\n    min-width: auto;\n    font-size: 8px;\n    padding: 2px 4px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
